import React from 'react';
import { ShieldCheck, Mail, FileText, Lock } from 'lucide-react';
export function Footer({
  onNavigate
}: {
  onNavigate?: (page: string) => void;
}) {
  return <footer className="w-full bg-[#0a0a0a] border-t border-gray-800 pb-24 md:pb-8" data-id="element-83">
      {/* Main Footer Content */}
      <div className="max-w-6xl mx-auto px-4 py-12" data-id="element-84">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-12" data-id="element-85">
          {/* Brand Column */}
          <div className="space-y-4" data-id="element-86">
            <h3 className="text-lg font-bold text-white uppercase tracking-wider" data-id="element-87">
              A1C Shockproof <span className="text-accent" data-id="element-88">(50+)</span>
            </h3>
            <p className="text-sm text-gray-500 leading-relaxed" data-id="element-89">
              The Glucose Interception Manual. A metabolic engineering protocol
              designed specifically for men over 50 fighting pre-diabetic lab
              results.
            </p>
            <div className="flex items-center gap-2 text-xs text-gray-600" data-id="element-90">
              <ShieldCheck className="w-4 h-4 text-accent" data-id="element-91" />
              <span data-id="element-92">60-Day Money-Back Guarantee</span>
            </div>
          </div>

          {/* Quick Links Column */}
          <div className="space-y-4" data-id="element-93">
            <h4 className="text-sm font-bold text-gray-400 uppercase tracking-widest" data-id="element-94">
              Quick Links
            </h4>
            <ul className="space-y-3" data-id="element-95">
              <li data-id="element-96">
                <button onClick={() => {
                onNavigate?.('privacy');
                window.scrollTo(0, 0);
              }} className="flex items-center gap-2 text-sm text-gray-500 hover:text-accent transition-colors duration-200" data-id="element-97">
                  <Lock className="w-3.5 h-3.5" data-id="element-98" />
                  Privacy Policy
                </button>
              </li>
              <li data-id="element-99">
                <button onClick={() => {
                onNavigate?.('terms');
                window.scrollTo(0, 0);
              }} className="flex items-center gap-2 text-sm text-gray-500 hover:text-accent transition-colors duration-200" data-id="element-100">
                  <FileText className="w-3.5 h-3.5" data-id="element-101" />
                  Terms of Service
                </button>
              </li>
              <li data-id="element-102">
                <a href="mailto:support@a1cshockproof.com" className="flex items-center gap-2 text-sm text-gray-500 hover:text-accent transition-colors duration-200" data-id="element-103">
                  <Mail className="w-3.5 h-3.5" data-id="element-104" />
                  Contact Support
                </a>
              </li>
            </ul>
          </div>

          {/* Disclaimer Column */}
          <div className="space-y-4" data-id="element-105">
            <h4 className="text-sm font-bold text-gray-400 uppercase tracking-widest" data-id="element-106">
              Medical Disclaimer
            </h4>
            <p className="text-xs text-gray-600 leading-relaxed" data-id="element-107">
              This manual is for educational purposes only and does not
              constitute medical advice. The information provided is not
              intended to diagnose, treat, cure, or prevent any disease. Always
              consult with your physician before starting any new diet,
              exercise, or supplementation program. Individual results may vary.
            </p>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-900" data-id="element-108">
        <div className="max-w-6xl mx-auto px-4 py-5 flex flex-col md:flex-row items-center justify-between gap-3" data-id="element-109">
          <p className="text-xs text-gray-700" data-id="element-110">
            © {new Date().getFullYear()} A1C Shockproof. All rights reserved.
          </p>
          <p className="text-xs text-gray-700" data-id="element-111">
            Secure 256-bit encrypted checkout powered by Stripe
          </p>
        </div>
      </div>
    </footer>;
}